$(document).ready( function () {
  $('.location-blocks > .column').each( function (index) {
    var self = $(this)
    var toggle = $(this).find('a.title')

    toggle.click(function(e){
      e.preventDefault()

      if ( !self.hasClass('active') ) {
        $('.column.active').removeClass('active')
        $('.location-blocks > .column').addClass('inactive')
        self.addClass('active').removeClass('inactive')
      } else {
        $('.column.active').removeClass('active')
        $('.column.inactive').removeClass('inactive')
      }
    })
  })
})

$(document).ready( function () {
  $('.location-links .link').each(function(){
    var $self = $(this)
    var dataLink = $self.data('link');
    var grid = $('.location-blocks')

    $self.click(function(e){
      e.preventDefault()
      var gridBlock = grid.find('.column#'+ dataLink +'')
      $('.column.active').removeClass('active')
      $('.location-blocks > .column').addClass('inactive')
      $('html,body').animate({scrollTop: gridBlock.offset().top},'slow');
      gridBlock.addClass('active').removeClass('inactive')
    })
  })
})

$(document).ready( function () {
  $('#clickable-map .link').each(function(){
    var $self = $(this)
    var dataLink = $self.data('link');
    var grid = $('.location-blocks')

    $self.click(function(e){
      e.preventDefault()
      var gridBlock = grid.find('.column#'+ dataLink +'')
      $('.column.active').removeClass('active')
      $('.location-blocks > .column').addClass('inactive')
      $('html,body').animate({scrollTop: gridBlock.offset().top},'slow');
      gridBlock.addClass('active').removeClass('inactive')
    })
  })
})

$(document).ready( function () {
  var $map = $('#map svg')
  var $states = $map.find('> path')
  var $locLinks = $('#location-links')

  $states.each( function(){
    var $self = $(this)
    var selfColor = $self.attr('fill')
    var pair
    if (selfColor != '#f0eded'){
      pair = $locLinks.find('[style="color: ' + selfColor + ';"]')
      $self.click(function(){
        pair.click()
      })
    }
  })
})
